import "./CommissionPage.scss";
import { HistoryCommission } from "./components";

export const CommissionPage = () => {
  return (
    <div className="CommissionPage">
      <HistoryCommission />
    </div>
  );
};
